import React, { useState } from 'react'
import { Flex } from 'reflexbox'

export default ({ chore, callback }) => {
  const { id, name = '', isCompleted = false } = chore
  const [checked, setChecked] = useState(isCompleted)

  const onClick = () =>
    callback({ choreId: id, is_completed: !checked })
      .then(() => setChecked(!checked))
      .catch(/* TODO: display some indication update failed */)

  return (
    <div
      className="px-6 py-4 tracking-wider rounded-lg bg-white shadow-md cursor-pointer"
      onClick={onClick}
    >
      <Flex alignItems="center">
        <div className="inline-block h-6 mr-3">
          <input
            type="checkbox"
            id={`checkbox-${id}`}
            checked={checked}
            onClick={(e) => e.stopPropagation()}
            readOnly={true}
          />
          <label htmlFor={`checkbox-${id}`} className="check-box" />
        </div>
        <div className="text-xl">{name}</div>
      </Flex>
    </div>
  )
}
